import { useState, useRef, useCallback } from 'react';

function useImageNaturalSize() {
  const imgRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  const setRef = useCallback(node => {
    if (node) {
      imgRef.current = node;

      const handleLoad = () => {
        if (node) {
          setSize({
            width: node.naturalWidth,
            height: node.naturalHeight,
          });
        }
      };

      node.addEventListener('load', handleLoad);

      if (node.complete) {
        handleLoad();
      }

      return () => {
        node.removeEventListener('load', handleLoad);
      };
    }
  }, []);

  return [setRef, size];
}

export default useImageNaturalSize;
